import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface CommunicatorUIState {
  sidenavVisible: boolean;
}

export const communicatorFeatureSelector = createFeatureSelector<any>('ui');

export const sidenavVisibleSelector = createSelector(communicatorFeatureSelector, (state: any) => state.sidenavVisible);
